import { hasFeature } from "../Actions/UserActions";
import { ScoutFeature } from "../Enums/ScoutFeature";
import { IUser } from "../Models/IUser";
import { App } from "../View/Products/Enums/App";

export const getAllReportsLink = (user: IUser): string => {
    return hasFeature(user, ScoutFeature.Scout4)
        ? `${window.location.origin}/Home/Scout#/reports`
        : `${window.location.origin}/Products#/MyReports`;
};

export const getSingleReportLink = (user: IUser, reportType: App, jobId: string): string => {
    const base = hasFeature(user, ScoutFeature.Scout4)
        ? `${window.location.origin}/Home/Scout#`
        : `${window.location.origin}/Products#/Reports`;

    let type: string;

    if (hasFeature(user, ScoutFeature.Scout4)) {
        type = reportType === App.Match ? "retailMatch" : "gps/insight";
    } else {
        type = reportType === App.Match ? "match" : "mobilytics";
    }

    return `${base}/${type}/${jobId}`;
};

export const getConfigReportingEnv = (): string | null => {
    const hostname = window.location.hostname;
    switch (hostname) {
        case "localhost":
            return "?env=dev";
        case "platform-qat.buxtonco.com":
            return "?env=qat";
        case "platform-uat.buxtonco.com":
            return "?env=uat";
        default:
            return "";
    }
};